import type { DeleteDocumentMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

const mapTrpcResponseToGraphQL = (): DeleteDocumentMutation => {
  return {
    deleteDocumentById: {
      __typename: 'GenericMutationOutput',
      affected_rows: 1,
    },
  };
};

export const useDeleteDocumentTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.document.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.document.register.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.document.documentById.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.document.list.queryKey(),
        });
      },
    }),
  });

  return {
    deleteDocument: async (id: string): Promise<DeleteDocumentMutation> => {
      await mutation.mutateAsync({ id });

      return mapTrpcResponseToGraphQL();
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
